import React from 'react';
import { Box, Button, Flex } from 'shared/components/display';

import { BrkfstUser } from 'shared/typings/user';
import Modal from 'shared/components/molecules/Modal';
import { SIZING } from 'shared/config/formatting';
import { BRIEF_COPY } from 'shared/config/copy';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import { LinkCreator } from 'shared/utilities/linkUtility';
import { UserType } from 'shared/typings/user/enums';

import styles from './styles';

const MANDATORY_FIELDS: { field: string; display: string }[] = [
  { field: 'gender', display: 'Gender' },
  { field: 'birthdate', display: 'Date of Birth (DOB)' },
  { field: 'lastName', display: 'Last Name' },
];

const formattedMessageValues = {
  b: (chunks) => <strong>{chunks}</strong>,
  ul: (chunks) => <ul>{chunks}</ul>,
  li: (chunks) => <li>{chunks}</li>,
};

interface Props {
  currentUser: BrkfstUser;
}
const ProfileInfoPrompt: React.FC<Props> = ({ currentUser }) => {
  const navigate = useNavigate();

  const missingMandatoryFields = MANDATORY_FIELDS.some((field) => !currentUser[field.field]);

  const goToAccountSettings = () => {
    navigate(
      LinkCreator.createLink({
        userType: UserType.CREATOR,
        routeKey: 'ACCOUNT_SETTINGS',
        variables: {
          userId: currentUser?.id,
        },
        query: {
          tab: 'Profile Info',
        },
      }),
    );
  };

  return (
    <Modal
      modalSize={SIZING.MEDIUM}
      title={BRIEF_COPY.MODAL_TITLE_PROFILE_INFO}
      component={
        <Box css={styles} className="profile-info-prompt" dataCy="profile-info-prompt">
          <Box className="profile-info-prompt__message">
            <FormattedMessage id="MODAL_PROFILE_INFO_P1" values={formattedMessageValues} />
            <ul>
              {MANDATORY_FIELDS.map((field) =>
                !currentUser[field.field] ? <li key={field.field}>{field.display}</li> : <></>,
              )}
            </ul>
            <FormattedMessage id="MODAL_PROFILE_INFO_P2" values={formattedMessageValues} />
          </Box>
          <Flex className="profile-info-prompt__footer">
            <Button onClick={goToAccountSettings}>{BRIEF_COPY.BUTTON_GO_TO_PROFILE_INFO}</Button>
          </Flex>
        </Box>
      }
      isOpen={missingMandatoryFields}
      hideCloseButton
    />
  );
};

export default ProfileInfoPrompt;
